export const AUTH_CRITERIA = {
  USER_NAME_MIN_LENGTH: 6,
  USER_NAME_MAX_LENGTH: 29,
  DISPLAY_NAME_MIN_LENGTH: 6,
  DISPLAY_NAME_MAX_LENGTH: 32,
  FULL_NAME_MAX_LENGTH: 32,
  PASSWORD_MIN_LENGTH: 6,
  PASSWORD_MAX_LENGTH: 32,
  PHONE_MIN_LENGTH: 10,
  PHONE_MAX_LENGTH: 10,
  EMAIL_MAX_LENGTH: 50,
  NO_SPACE: 'no-space'
}
